var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"System"},[_c('h1',[_vm._v("系统设置 ")]),_c('p',[_vm._v("版本号：2.0.25.1022")]),_c('p',[_vm._v("\n    更新时间：2024年10月22日\n  ")]),_c('p',[_vm._v("\n    持续更新中，请等待。。。。\n  ")])])
}]

export { render, staticRenderFns }